module.exports = __webpack_public_path__ + "img/design_geotagger.3ca49ac1.jpg";